module.exports = __webpack_public_path__ + "media/images/emblems/Romanel-sur-Morges-coat_of_arms-6d5bf2145be4b560133f371f2e502241.svg";